// Ported from the validated lesson-planner engine (index.html EXERCISE_TYPES,
// lines 1064-1073 as of 2026-08-14). Mirrors backend/curriculum_data.py.
export const EXERCISE_TYPES = [
  { key: "gapfill", label: "Gap fill" },
  { key: "matching", label: "Match the answers" },
  { key: "spotmistake", label: "Spot the mistake" },
  { key: "multiplechoice", label: "Multiple choice" },
  { key: "truefalse", label: "True or false" },
  { key: "wordorder", label: "Word order" },
  { key: "guidedwriting", label: "Guided writing" },
  { key: "pictureqa", label: "Picture-based questions" },
];
